import { Injectable } from "@angular/core";
import { DataActions } from "@app/project/store/actions";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { EquatorHistoryService } from "../../../shared/services/equator-api/equator-history/equator-history.service";
import { ServiceEvent } from "../../model/event-log";
import { ActivityLogActions } from "../actions";

@Injectable()
export class EventLogEffects {
    constructor(private actions$: Actions, private dbService: EquatorHistoryService) {}
    loadActivity$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ActivityLogActions.load),
            switchMap(({ uuid, params }) => {
                const key = this.createLogKey(uuid, params);
                return DataActions.toAction2()(
                    this.dbService.getServiceEventLog(uuid, params).pipe(
                        map((d: { measurement_properties: { service_event: ServiceEvent }[]; serverTimezone?: string }) => ({
                            ...d,
                            measurement_properties: d.measurement_properties?.map(prop => prop.service_event),
                            key,
                        })),
                        catchError(e => throwError(() => e))
                    ),
                    ActivityLogActions.loadSuccess,
                    ActivityLogActions.loadFailure
                );
            })
        )
    );

    private createLogKey(uuid: string, params) {
        return `${uuid}:${JSON.stringify(params)}`;
    }
}
